<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="17"
    viewBox="0 0 30 17"
    class="group"
  >
    <g id="Hamburger" transform="translate(0 0.5)">
      <g
        id="Group_1977"
        data-name="Group 1977"
        transform="translate(-13411.246 -16.533)"
      >
        <path
          id="Path_206"
          data-name="Path 206"
          d="M13175.246,36.533h30"
          transform="translate(236 -8)"
          fill="none"
          stroke="#000"
          stroke-width="1"
          class="translate-x-[236px] translate-y-[-6px] transition duration-300 group-hover:translate-y-[-4px]"
        />
        <path
          id="Path_208"
          data-name="Path 208"
          d="M13175.246,36.533h30"
          transform="translate(236 -20)"
          fill="none"
          stroke="#000"
          stroke-width="1"
          class="translate-x-[236px] translate-y-[-18px] transition duration-300 group-hover:translate-y-[-20px]"
        />
        <path
          id="Path_867"
          data-name="Path 867"
          d="M13175.246,36.533h30"
          transform="translate(236 -12)"
          fill="none"
          stroke="#000"
          stroke-width="1"
        />
      </g>
    </g>
  </svg>
</template>
